import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Card, CardContent, Typography, Avatar } from '@weave-mui/material';
import { ACCENT_COLORS, accentCardSx } from '../../utils/accentColors';
import { formatRelativeTime } from '../../utils/formatRelativeTime';
const SOURCE_ACCENT = {
    github: ACCENT_COLORS.purple,
    slack: ACCENT_COLORS.pink,
    manual: ACCENT_COLORS.gray,
    scheduled: ACCENT_COLORS.green,
};
/**
 * Splits an email/username into first/last parts so the Avatar shows two-letter
 * initials (e.g. "maowen.zhang@..." -> "MZ") instead of just the first character.
 */
function ownerNameParts(owner) {
    const localPart = owner.split('@')[0];
    const segments = localPart.split(/[._-]/).filter(Boolean);
    return segments.length >= 2
        ? { firstName: segments[0], lastName: segments[segments.length - 1] }
        : { name: localPart };
}
export default function TaskCard({ task, onClick, selected, multiSelected, dragTaskIds }) {
    const accent = SOURCE_ACCENT[task.source] ?? SOURCE_ACCENT.manual;
    const shortId = task.sourceId ?? task.taskId.slice(0, 8).toUpperCase();
    const ownerParts = task.owner ? ownerNameParts(task.owner) : undefined;
    const title = task.title.replace(/^Handle\s+/, '').trim() || task.title;
    return (_jsx(Card, { variant: "outlined", sx: {
            ...accentCardSx(accent, { selected, multiSelected }),
            cursor: 'pointer',
        }, draggable: true, onDragStart: (e) => {
            const ids = dragTaskIds && dragTaskIds.length > 0 ? dragTaskIds : [task.taskId];
            if (ids.length > 1) {
                e.dataTransfer.setData('taskIds', ids.join(','));
            }
            else {
                e.dataTransfer.setData('taskId', ids[0]);
            }
        }, onClick: onClick, children: _jsxs(CardContent, { sx: { pb: '8px !important' }, children: [_jsxs(Box, { sx: { display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', gap: 1 }, children: [_jsx(Typography, { variant: "body2", fontWeight: "bold", noWrap: true, sx: { flex: 1 }, children: title }), _jsx(Avatar, { ...ownerParts, size: "XS", sx: { width: 24, height: 24, fontSize: '0.65rem', flexShrink: 0 } })] }), _jsxs(Typography, { variant: "caption", color: "text.secondary", display: "block", gutterBottom: true, children: [shortId, " \u00B7 ", task.taskType] }), _jsxs(Typography, { variant: "caption", display: "block", color: "text.secondary", children: [_jsx(Box, { component: "span", sx: {
                                display: 'inline-block',
                                width: 8,
                                height: 8,
                                borderRadius: '50%',
                                bgcolor: accent,
                                mr: 0.75,
                                verticalAlign: 'middle',
                            } }), task.source, task.scheduleId && ' · from schedule', ' · ', formatRelativeTime(task.updatedAt)] })] }) }));
}
